module.exports = __webpack_public_path__ + "static/eljazz-a3a6b24a6a9d0ce5b9c5234a50cbfad0.pdf";